import { t } from '@lingui/core/macro'
import React from 'react'
import { Tooltip } from '@tecsinapse/cortex-react'
import { IoMdInformationCircleOutline } from 'react-icons/io'
import { FormMultiGroupedSelect } from '../../hook-form-connectors/form-multi-grouped-select'
import { OptionSelect } from '@/core/utils/types'

const tooltipMessage = t`Caso nenhum perfil for selecionado, todos os usuários serão incluídos.`

export const TiposAcessos = ({
  options
}: {
  options: Map<string, OptionSelect[]>
}) => (
  <div className={'flex flex-col flex-1'}>
    <div className={'flex flex-row items-center gap-x-micro'}>
      <Tooltip text={tooltipMessage}>
        <IoMdInformationCircleOutline className='text-sub' />
      </Tooltip>
      <span className='font-bold text-sub'>{t`Selecionar Perfis`}</span>
    </div>
    <div
      className={
        'h-full overflow-y-scroll grid grid-cols-1 sm:grid-cols-2 gap-deca'
      }
    >
      <FormMultiGroupedSelect
        name='tiposAcesso'
        options={options}
        groupedLabelExtractor={(label: string) => `${label}`}
        label={t`Perfil de Acesso do Usuário`}
        withSearch
      />
    </div>
  </div>
)
